import React, {useEffect} from "react";
import { ToastContainer, toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import {deleteClientById} from "../../utilities/ClientApi";
import keycloak from "../../Keycloak";

const showDeleteSuccess = () => {
    toast.success("Client successfully deleted", {
        position: toast.POSITION.TOP_LEFT,
        style: {
            backgroundColor: "#49C96D",
            width: "650px",
            color: "#FFFFFF",
            left: "400px",
            theme: "light",
        },
        onClose: () => {
            window.location.reload();
        }
    });
};

const showDeleteError = () => {
    toast.error("Client could not be deleted as they still have active service requests", {
        position: toast.POSITION.TOP_LEFT,
        style: {
            backgroundColor: "#eb4335",
            width: "650px",
            color: "#FFFFFF",
            left: "400px",
            theme: "light",
        },
    })
}

let paramToChange;
let action;

const Delete = ({ open, onClose, clientId }) => {
    // Scroll to top of page on mounted
    useEffect(() => {
        window.scrollTo(0, 0);
    }, [])

    const navigate = useNavigate();
    let path;
    if (!open) return null;

     if (window.location.href.includes("/ClientList") || window.location.href.includes("/EditClient")){
        paramToChange = "Delete Client";
        path= "/ClientList";
        action = "delete this client";
    }

     const deleteEntity = () => {
         deleteClientById(clientId, keycloak.token)
             .then(() =>{
                 showDeleteSuccess();
             })
             .catch((e) => {
                 showDeleteError()
                 console.log(e);
             })

         //add if else for deleting service request?
    }

    return (
        <div className={"overlay"}>
            <ToastContainer newestOnTop={true} />
            <div className="overlayMain">
                <div className="modalContainer">
                    <div className="content">
                        {/* <h3>Cancel Service Request</h3> */}
                        <h3>{paramToChange}</h3>
                        <br></br>
                        <p>Are you sure you want to {action}?</p>
                    </div>
                    <div className="btnContainer">
                        <button
                            className="btnPrimary"
                            onClick={() => {
                                    navigate(path, { state: { showToast: true } });
                                    deleteEntity();
                                    onClose();
                            }}
                        >
                            <span>YES</span>
                        </button>
                        <button className="btnSecondary" onClick={onClose}>
                            NO
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Delete;
